<template>
	<v-dialog v-model="visible" :max-width="maxWidth">
		<v-card :loading="loading" class="pa-4">
			<WizardSceneWrapper
				v-if="scene"
				:key="scene.name"
				:scene="scene"
				:loading.sync="loading"
				@submit="visible = false"
				@cancel="visible = false"
			/>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapMutations } from "vuex";
export default {
	props: {
		maxWidth: { type: Number, default: 440 },
	},

	data() {
		return {
			visible: false,
			loading: false,

			scene: null,
		};
	},

	watch: {
		visible(v) {
			if (!v) {
				this.setEditMode(false);
			}
		},
	},

	methods: {
		...mapMutations("scenes", ["setEditMode"]),

		pop(scene) {
			this.visible = true;
			this.scene = scene;
			this.setEditMode(true);
		},
	},
};
</script>
